import React, { Suspense, Fragment, lazy } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';

import Loader from './components/Loader/Loader';
import AdminLayout from './layouts/AdminLayout';

import { BASE_URL } from './config/constant';
import { title } from 'process';
import Users from './components/users';
import Login from './views/auth/login';
import Metal from './components/metal';
import Faqs from './components/faqs';
import Blogs from './components/blogs';
import Category from './components/category';
import CategoryStyle from './components/categoryStyle';
import Product from './components/product';
import ProductShape from './components/productShape';
import ProductDetails from './components/productDetails';
import ProductReview from './components/productReview';
import CustomerReview from './components/customerReview';
import ProductAdBanner from './components/productAdBanner';
import PageBanner from './components/pageBanner';
import PageName from './components/pageName';
import Profile from './components/profile';
import Footer from './components/footer';
import UserShape from './components/userShape';
import PrivateRoute from './helper/PrivateRoute';
import ChangePassword from './views/auth/changePassword';
import Engrave from './components/engrave';
import DropMail from './components/dropMail';
import ContactUs from './components/contact';
import AddEditProductDetail from './components/addEditProductDetail'
import Wish from './components/wish'

export const renderRoutes = (routes = []) => (
  <Suspense fallback={<Loader />}>
    <Routes>
      {routes.map((route, i) => {
        const Guard = route.guard || Fragment;
        const Layout = route.layout || Fragment;
        const Element = route.element;

        return (
          <Route
            key={i}
            path={route.path}
            element={
              <Guard>
                <Layout>{route.routes ? renderRoutes(route.routes) : <Element props={true} title={route?.title} />}</Layout>
              </Guard>
            }
          />
        );
      })}
    </Routes>
  </Suspense>
);

const routes = [
  {
    exact: 'true',
    path: '/login',
    title: "Login",
    element: <Login />
  },
  {
    exact: 'true',
    path: '/change-password',
    title: "Change Password",
    element: <PrivateRoute><ChangePassword /></PrivateRoute>
  },
  {
    exact: 'true',
    path: '/',
    title: "Users",
    private: true,
    element: <PrivateRoute><Users title="Users" /></PrivateRoute>
  },
  {
    exact: 'true',
    path: '/metal',
    title: "Metal",
    private: true,
    element: <PrivateRoute><Metal title="Metal" /></PrivateRoute>
  },
  {
    exact: 'true',
    path: '/faqs',
    title: "FAQs",
    private: true,
    element: <PrivateRoute><Faqs title="FAQs" /></PrivateRoute>
  },
  {
    exact: 'true',
    path: '/blogs',
    title: "Blogs",
    private: true,
    element: <PrivateRoute><Blogs title="Blogs" /></PrivateRoute>
  },
  {
    exact: 'true',
    path: '/category',
    title: "Category",
    private: true,
    element: <PrivateRoute>< Category title="Category" /></PrivateRoute>
  },
  {
    exact: 'true',
    path: '/category-style',
    title: "Category Style",
    private: true,
    element: <PrivateRoute><CategoryStyle title="Category Style" /></PrivateRoute>
  },
  {
    exact: 'true',
    path: '/product-carat',
    title: "Product Carat",
    private: true,
    element: <PrivateRoute><Product title="Product Carat" /></PrivateRoute>
  },
  {
    exact: 'true',
    path: '/product-shape',
    title: "Product shape",
    private: true,
    element: <PrivateRoute><ProductShape title="Product shape" /></PrivateRoute>
  },
  {
    exact: 'true',
    path: '/product-details',
    title: "Product Details",
    private: true,
    element: <PrivateRoute><ProductDetails title="Product Details" /></PrivateRoute>
  },
  // {
  //   exact: 'true',
  //   path: '/wish',
  //   title: "Wish",
  //   private: true,
  //   element: <PrivateRoute><Wish title="Wish" /></PrivateRoute>
  // },
  {
    exact: 'true',
    path: '/product-review',
    title: "Product Review",
    private: true,
    element: <PrivateRoute><ProductReview title="Product Review" /></PrivateRoute>
  },
  {
    exact: 'true',
    path: '/customer-review',
    title: "Customer Review",
    private: true,
    element: <PrivateRoute><CustomerReview title="Customer Review" /></PrivateRoute>
  },
  {
    exact: 'true',
    path: '/customer-review',
    title: "Customer Review",
    private: true,
    element: <PrivateRoute>< ProductAdBanner title="Customer Review" /></PrivateRoute>
  },
  {
    exact: 'true',
    path: '/product-ad-banner',
    title: "Product Ad Banner",
    private: true,
    element: <PrivateRoute><ProductAdBanner title="Product Ad Banner" /></PrivateRoute>
  },
  {
    exact: 'true',
    path: '/page-banner',
    title: "Page Banner",
    private: true,
    element: <PrivateRoute>< PageBanner title="Page Banner" /></PrivateRoute>
  },
  {
    exact: 'true',
    path: '/page-name',
    title: "Page Name",
    private: true,
    element: <PrivateRoute>< PageName title="Page Name" /></PrivateRoute>
  },
  {
    exact: 'true',
    path: '/profile',
    title: "Profile",
    private: true,
    element: <PrivateRoute>< Profile title="Profile" /></PrivateRoute>
  },
  {
    exact: 'true',
    path: '/footer',
    title: "Footer",
    private: true,
    element: <PrivateRoute>< Footer title="Footer" /></PrivateRoute>
  },
  {
    exact: 'true',
    path: '/user-shape',
    title: "User Shape",
    private: true,
    element: <PrivateRoute><UserShape title="User Shape" /></PrivateRoute>
  },
  {
    exact: 'true',
    path: '/engrave',
    title: "Engrave",
    private: true,
    element: <PrivateRoute><Engrave title="Engrave" /></PrivateRoute>
  },
  {
    exact: 'true',
    path: '/drop-mail',
    title: "Drop Mail",
    private: true,
    element: <PrivateRoute><DropMail title="Drop Mail" /></PrivateRoute>
  },
  {
    exact: 'true',
    path: '/contact-us',
    title: "Contact Us Query",
    private: true,
    element: <PrivateRoute><ContactUs title="Contact Us Query" /></PrivateRoute>
  },
  {
    exact: 'true',
    path: '/add-product',
    title: "Add Product",
    private: true,
    element: <PrivateRoute><AddEditProductDetail title="Add Product" /></PrivateRoute>
  },
  {
    exact: 'true',
    path: '/edit-product',
    title: "Edit Product",
    private: true,
    element: <PrivateRoute><AddEditProductDetail title="Edit Product" /></PrivateRoute>
  },
  {
    path: '*',
    exact: 'true',
    element: () => <Navigate to={BASE_URL} />
  }
];

export default routes;
